var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#00C6B8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23643_36311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 14.25V13.3333C13.3333 12.8471 13.1402 12.3808 12.7964 12.037C12.4525 11.6932 11.9862 11.5 11.5 11.5H7.83333C7.3471 11.5 6.88079 11.6932 6.53697 12.037C6.19315 12.3808 6 12.8471 6 13.3333V14.25",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83333 9.66667C10.8459 9.66667 11.6667 8.84586 11.6667 7.83333C11.6667 6.82081 10.8459 6 9.83333 6C8.82081 6 8 6.82081 8 7.83333C8 8.84586 8.82081 9.66667 9.83333 9.66667Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5415 14.25V13.3333C16.5412 12.9271 16.406 12.5325 16.1571 12.2115C15.9083 11.8904 15.5598 11.6611 15.1665 11.5596",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 6.05957C13.7279 6.16054 14.0774 6.38989 14.327 6.71146C14.5766 7.03303 14.7121 7.42853 14.7121 7.83561C14.7121 8.24269 14.5766 8.63819 14.327 8.95976C14.0774 9.28133 13.7279 9.51068 13.3335 9.61165",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14.1904V13.2738C3.0003 12.8675 3.1355 12.4729 3.38437 12.1519C3.63324 11.8309 3.98169 11.6016 4.375 11.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20801 6C5.81365 6.10097 5.46412 6.33032 5.21451 6.65189C4.9649 6.97346 4.82941 7.36896 4.82941 7.77604C4.82941 8.18312 4.9649 8.57862 5.21451 8.90019C5.46412 9.22176 5.81365 9.45111 6.20801 9.55208",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23643_36311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 12,
    fill: "white",
    transform: "translate(2.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/groupIcon.d5a791092e778ca00941d4a209178ec9.svg";
export { ForwardRef as ReactComponent };